module.exports = __webpack_public_path__ + "static/media/main-egg.537185d8.png";